import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminUser, CreateAdminUser } from '@src/app/types/gwc-api/admin-user.types';
import { GwcApiConnService } from './gwc-api-conn.service';

@Injectable({ providedIn: 'root' })
export class GwcApiAdminUsersService {
    constructor(private _connService: GwcApiConnService) {}

    getUsers(): Observable<AdminUser[]> {
        return this._connService.request('GET', ['Auth', 'users']);
    }

    createUser(user: CreateAdminUser): Observable<{ message: string; user: AdminUser }> {
        return this._connService.request('POST', ['Auth', 'register'], null, user);
    }

    changePassword(data: { current_password: string; password: string; password_confirmation: string }): Observable<{ message: string }> {
        return this._connService.request('PUT', ['Auth', 'password'], null, data);
    }

    resetUserPassword(userId: string, data: { password: string; password_confirmation: string }): Observable<{ message: string }> {
        return this._connService.request('PUT', ['Auth', 'users', userId, 'password'], null, data);
    }
}
